import _styled from "styled-components";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Container } from "@crehana/ui";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
var NavbarContainer = function NavbarContainer(_ref) {
  var className = _ref.className,
    _ref$navType = _ref.navType,
    navType = _ref$navType === void 0 ? 'default' : _ref$navType,
    children = _ref.children;
  return /*#__PURE__*/_jsx(_StyledContainer, {
    className: className,
    type: navType,
    $_css: navType === 'dashboard' && "\n          max-width: 100% !important;\n          width: calc(100% - 128px);\n        ",
    children: children
  });
};
export default NavbarContainer;
var _StyledContainer = /*#__PURE__*/_styled(Container).withConfig({
  componentId: "sc-ype0cd-0"
})(["\n      ", " {\n        width: calc(100% - 80px);\n      }\n      ", " {\n        ", "\n      }\n    "], function (props) {
  return props.theme.breakpoints.up('md');
}, function (props) {
  return props.theme.breakpoints.up('sm');
}, function (p) {
  return p.$_css;
});